import { useMemo } from "react";

export interface UpdatedAtCellPropsHook {
  timestamp: number;
}

export default function useUpdatedAtCellProps(
  date?: Date | string
): UpdatedAtCellPropsHook {
  const timestamp = useMemo(() => new Date(date as string).getTime(), [date]);

  return { timestamp };
}
